import { PersonInterface } from '../enums/person.interface'

export const getFullNameUtil = (user: PersonInterface): string => {
  return [user?.last_name.trim(), user?.first_name.trim()].join(' ')
}
